module.exports = __webpack_public_path__ + "img/silver4.3817b4e2.png";